import { render, staticRenderFns } from "./ContactPreferences.vue?vue&type=template&id=1aeac891&scoped=true&"
import script from "./ContactPreferences.vue?vue&type=script&lang=js&"
export * from "./ContactPreferences.vue?vue&type=script&lang=js&"
import style0 from "./ContactPreferences.vue?vue&type=style&index=0&id=1aeac891&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aeac891",
  null
  
)

export default component.exports